module.exports = __webpack_public_path__ + "media/images/flags/1x1/vct-be22d370bf65174473c8ff61b404fc8c.svg";